import Menu from './Menu';
import gradesService from '../../services/grades';

export default function GenerateMenu() {
  const grades = gradesService.GRADES;
  const contentFacts = {
    worksheet: {
      urlName: '/worksheets/',
      title: 'All Worksheets',
    },
    game: {
      urlName: '/games/',
      title: 'All Games',
    },
    'lesson-plan': {
      urlName: '/lesson-plans/',
      title: 'All Lesson Plans',
    },
    skills: {
      urlName: '/skills/',
      title: 'All Grades',
      regularLink: true,
    },
    more: {
      urlName: '/resources/',
    },
  };

  Menu.map(item => {
    if (item.type in contentFacts) {
      item.sections.map(section => {
        if (['By Grade', 'Grades'].includes(section.title) && !section.pushed) {
          grades.forEach(grade => {
            section.links.push({
              title: grade.abbreviated,
              link: contentFacts[item.type].urlName + grade.internal + '/',
            });
          });
          // Push "All"
          if (contentFacts[item.type].title) {
            section.links.push({
              title: contentFacts[item.type].title,
              link: contentFacts[item.type].urlName,
              bold: true,
            });
          }
          section.pushed = true;
        }
      });
    }
  });

  return Menu;
}
